import React from 'react';
import Select from "@amzn/awsui-components-core/select";
import { useUser } from 'src/context/UserContext';
import { AVAILABLE_GROUPS } from 'src/constants';

/**
 * Group values hidden from the role switcher. 'cm' has no base users today
 * (everyone in CM is a supervisor, 'cm-sup'). The group is intentionally kept
 * in AVAILABLE_GROUPS and the permission logic so it can be re-enabled if CM
 * base users are added later — just remove it from this list.
 */
const HIDDEN_GROUP_VALUES = ['cm'];

const ROLE_OPTIONS = [
    { label: 'No Override', value: '' },
    ...AVAILABLE_GROUPS.filter(g => !HIDDEN_GROUP_VALUES.includes(g.value))
];

/**
 * Role switcher dropdown for dev/testing purposes.
 * Allows switching the active role to test different permission levels.
 */
const RoleSwitcher: React.FC = () => {
    const { roleOverride, setRoleOverride } = useUser();

    return (
        <div className="role-switcher">
            <Select
                placeholder="Switch Role"
                options={ROLE_OPTIONS}
                selectedOption={ROLE_OPTIONS.find(o => o.value === (roleOverride || '')) || null}
                onChange={({ detail }) => {
                    const val = detail.selectedOption.value;
                    setRoleOverride(val || null);
                }}
            />
        </div>
    );
};

export default RoleSwitcher;
